import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CloseAccountRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CloseAccountResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const closeAccount = (request: CloseAccountRequest, options?: CashRequestOptions) =>
  post<CloseAccountRequest, CloseAccountResponse>('/2.0/cash/close-account', request, {
    ...options,
    rejectOnError: true,
  })
